import React from "react";
import { useAlertNotification } from "../common/hooks/useAlertNotification";
import AlertNotification from "../common/AlertNotification";

const AlertNotificationContainer = () => {
  const { getAlert, clearAlert } = useAlertNotification();
  const alert = getAlert();
  return (
    <AlertNotification
      message={alert?.message}
      severity={alert?.severity}
      onClose={() => setTimeout(clearAlert, 1500)}
      duration={3000}
    />
  );
};

export default AlertNotificationContainer;
